import { FileText } from "lucide-react";
import { useGet } from "@/context/AuthContext";
import { api } from "@/lib/api";

const SCOPE = { FOOD: "Food", BEVERAGE: "Beverage", COMBINED: "Combined" };

const openPdf = async (id) => {
  const r = await api.get(`/files/${id}`, { responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank", "noopener");
};

export function AppReports() {
  const { data } = useGet("/inv/app-reports");
  const items = data?.items || [];
  return (
    <div className="card-surface p-4" data-testid="ov-app-reports">
      <div className="text-sm font-medium mb-2 flex items-center gap-2"><FileText className="h-4 w-4" />Inventory reports from the 86'd Inventory app</div>
      {items.map((r) => (
        <div key={r.id} className="flex flex-wrap items-center justify-between gap-2 text-sm py-1.5 border-t" data-testid={`app-report-${r.id}`}>
          <span>{SCOPE[r.inventory_scope]} · {r.period?.start} → {r.period?.end}{r.grade ? ` · grade ${r.grade}` : ""}{r.totals?.closing_value ? ` · closing $${r.totals.closing_value}` : ""}</span>
          <span className="flex items-center gap-2">
            <span className={`text-xs px-2 py-0.5 rounded-full ${r.status === "final" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`} data-testid={`app-report-status-${r.id}`}>{r.status === "final" ? "Final" : "Provisional"}</span>
            {r.pdf_file_id && <button type="button" onClick={() => openPdf(r.pdf_file_id)} className="text-xs underline" data-testid={`app-report-pdf-${r.id}`}>PDF</button>}
          </span>
        </div>
      ))}
      {!items.length && <div className="text-sm text-stone-500">No reports from the app yet.</div>}
    </div>
  );
}
